// extracted by mini-css-extract-plugin
module.exports = {"online-status":"live-button_online-status__O17_5","off":"live-button_off__pyfbB","live-status":"live-button_live-status__9Nkdp","scaling":"live-button_scaling__s4h8a"};